import { Component } from '@angular/core';

@Component({
  selector: 'things-details-page',
  templateUrl: './details.component.html',
  styleUrls: []
})
export class ThingsDetailsPageComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/pages/things/details.component.ts